const timeToMinutes = (timeStr) => {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(':').map(Number);
    return (h * 60) + m;
};

const DIAS_KEYS = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];

export const analyzeWeeklyAttendance = (rawLogs, employees, permissions, startDateStr, endDateStr) => {
    const report = [];
    const start = new Date(startDateStr + 'T00:00:00');
    const end = new Date(endDateStr + 'T23:59:59');

    const daysOfWeek = [];
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        daysOfWeek.push(new Date(d).toISOString().split('T')[0]); 
    }

    employees.forEach(emp => {
        if (!emp.idReloj) return;

        const empReport = {
            uid: emp.id,
            nombre: emp.nombre || emp.nombreCompleto,
            idReloj: emp.idReloj,
            dias: [],
            resumen: { 
                retardos: 0, 
                faltas: 0, 
                incidencias: 0, 
                sinSalida: 0,
                totalHorasExtra: 0
            }
        };

        const empIdString = String(emp.idReloj).trim();
        const toleranciaMinutos = emp.horarioLaboral?.tolerancia ? Number(emp.horarioLaboral.tolerancia) : 10;

        daysOfWeek.forEach(diaStr => {
            const fechaObj = new Date(diaStr + 'T12:00:00');
            const diaIndex = fechaObj.getDay(); 
            const nombreDiaKey = DIAS_KEYS[diaIndex];
            const configDia = emp.horarioLaboral?.[nombreDiaKey] || {};
            const esDiaLaboral = configDia.activo === true;
            const horaEntradaOficial = configDia.entrada || "09:00";
            const horaSalidaOficial = configDia.salida || "18:00";

            const logsDelDia = rawLogs.filter(log => {
                return String(log.userId).trim() === empIdString && log.fecha === diaStr;
            }).sort((a, b) => a.timestamp - b.timestamp);

            const entradaReal = logsDelDia.length > 0 ? logsDelDia[0].hora : null;
            const salidaReal = logsDelDia.length > 1 ? logsDelDia[logsDelDia.length - 1].hora : null;

            const permisoDia = permissions.find(p => 
                p.uid === emp.id && 
                p.estado && p.estado.includes('Aprobado') &&
                diaStr >= p.fechaInicio.toDate().toISOString().split('T')[0] && 
                diaStr <= p.fechaFin.toDate().toISOString().split('T')[0]
            );

            let estatus = 'Asistencia';
            let color = 'text-green-600';
            let requiereFormato = false;
            let horasExtraDia = 0;

            if (entradaReal && salidaReal) {
                const minsEntrada = timeToMinutes(entradaReal);
                const minsSalida = timeToMinutes(salidaReal);

                if (!esDiaLaboral) {
                    const duracion = minsSalida - minsEntrada;
                    if (duracion > 60) horasExtraDia = Math.floor(duracion / 60);
                } else {
                    const minsSalidaOficial = timeToMinutes(horaSalidaOficial);
                    if (minsSalida > minsSalidaOficial) {
                        const extra = minsSalida - minsSalidaOficial;
                        if (extra >= 60) horasExtraDia = Math.floor(extra / 60);
                    }
                }
            }
            
            if (permisoDia) {
                if (permisoDia.tipo === 'vacaciones') {
                    estatus = 'Vacaciones'; color = 'text-blue-500 font-bold';
                } else if (permisoDia.tipo === 'llegada_tarde') {
                    estatus = 'Llegada Tarde (OK)'; color = 'text-yellow-600';
                } else {
                    estatus = 'Justificado'; color = 'text-purple-600';
                }
            }
            else if (!esDiaLaboral) { 
                if (entradaReal) {
                    estatus = 'Asistencia Extra'; 
                    color = 'text-blue-700 font-bold';
                } else {
                    estatus = 'Descanso'; 
                    color = 'text-gray-400';
                }
            }
            else if (!entradaReal) {
                estatus = 'Falta Injustificada';
                color = 'text-red-600 font-bold bg-red-50';
                requiereFormato = true;
                empReport.resumen.faltas++;
                empReport.resumen.incidencias++;
            }
            else if (entradaReal && !salidaReal) {
                estatus = 'Sin Salida';
                color = 'text-orange-600 font-bold';
                requiereFormato = true;
                empReport.resumen.sinSalida++;
                empReport.resumen.incidencias++;
            }
            else {
                const minsEntrada = timeToMinutes(entradaReal);
                const minsEntradaOficial = timeToMinutes(horaEntradaOficial);
                
                if (minsEntrada > (minsEntradaOficial + toleranciaMinutos)) {
                    estatus = `Retardo (${entradaReal})`;
                    color = 'text-red-500 font-bold';
                    requiereFormato = true;
                    empReport.resumen.retardos++;
                    empReport.resumen.incidencias++;
                }
            }

            empReport.resumen.totalHorasExtra += horasExtraDia;

            empReport.dias.push({
                fecha: diaStr,
                diaSemana: diaIndex,
                entrada: entradaReal || '--:--',
                salida: salidaReal || '--:--',
                estatus,
                color,
                requiereFormato,
                horasExtra: horasExtraDia
            });
        });

        report.push(empReport);
    });

    return report;
};